export default __webpack_public_path__ + "static/media/copy-dark.7ae847dc.svg";